<template>
    <div id="optCategory" class="opt_g" :class="{opt_open: this.openedLayer === 'category'}" @click.stop="openLayer">
        <div class="opt_selected">
            <span class="tf_opt">
                <span class="txt_selected" id="optCateText">{{ categoryText[category] }}</span>
                <span class="ico_cafetop ico_arrow">옵션 더 보기</span>
            </span>
        </div>
        <div id="optCategory_layer" class="opt_layer" v-show="openedLayer === 'category'">
            <ul class="list_opt"  @click.stop="setCategory">
                <li id="optCate_all" :class="{ on: category === 'all' }">전체분야</li>
                <li id="optCate_musician" :class="{ on: category === 'musician' }">가수</li>
                <li id="optCate_actor" :class="{ on: category === 'actor' }">배우</li>
                <li id="optCate_sportsman" :class="{ on: category === 'sportsman' }">스포츠</li>
                <li id="optCate_entertainer" :class="{ on: category === 'entertainer' }">방송인</li>
                <li id="optCate_etc" :class="{ on: category === 'etc'}">기타</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
      return {
          categoryText: {
              all: "전체분야",
              musician: "가수",
              actor: "배우",
              sportsman: "스포츠",
              entertainer: "방송인",
              etc: "기타"
          }
      }  
    },
    computed: {
        ...mapState(["category", "openedLayer"])
    },
    methods: {
        openLayer() {
            this.$store.commit("setOpenedLayer", "category");
        },
        closeLayer() {
            this.$store.commit("setOpenedLayer", "");
        },
        setCategory(e) {
            const category = e.target.id.replace("optCate_", "");
            this.$store.commit("setCategory", category);

            this.$emit('reset-rank-num');
            
            this.closeLayer();
        }
    }
}
</script>
